import { CalculationModel } from '../Custom Types/Calculation';
import { GPChestPainCalculationHelper } from '../Helpers/GPChestPainCalculationHelper';
import { probabilityOfMACE, edacsTotal } from './GPChestPain-CalculationData';
import { redux } from '../../../components/App';
import { saveCalculation } from '../../../components/state/actions/CalculationActions';
import { removeResultsAlertValue, postResultsBadge } from '../../../components/state/actions/NotificationsActions';

export class GPChestPainCalculations {
    update(pathwayId, workflow, calculations, form) {
        // Refer to mainForm or the parent of the form (mainForm)
        let mainForm = form.parent != null ? form.parent : form;

        let progress = mainForm.completionProgress(['followUpBloodsDateAndTime', 'followUpBloodsTroponin']);
        let formComplete = (progress.current / progress.total) == 1;

        let patientEligable = workflow.rawData['patientSex'] != 'genderOtherOption';

        let edacsScore = null;
        let edacsRequiresUpdate = false;

        let riskBracket = null;
        let riskBracketRequiresUpdate = false;

        let maceScore = null;
        let maceRequiresUpdate = false;
        probabilityOfMACE;
        if (formComplete && patientEligable) {
            let maceCalculationErrors = GPChestPainCalculationHelper.calcualtionError('probabilityOfMACE', workflow.rawData, form);
            maceScore = maceCalculationErrors == null ? probabilityOfMACE(workflow.rawData) : null;
        }

        let edacsCompletionProgress = mainForm.subform('initialAssessment').completionProgress();
        let edacsCompleted = (edacsCompletionProgress.current / edacsCompletionProgress.total) == 1;
        if (edacsCompleted && patientEligable) {

            let calculatedEDACSErrors = GPChestPainCalculationHelper.calcualtionError('calculatedEDACS', workflow.rawData, form);
            edacsScore = calculatedEDACSErrors == null ? edacsTotal(workflow.rawData) : null;
        }

        if (workflow.rawData['calculatedEDACS'] != edacsScore) {
            edacsRequiresUpdate = true;
        }

        if (edacsRequiresUpdate) {
            let edacsCalculation = new CalculationModel(workflow.uuid, workflow.versionUuid, edacsScore, false, CalculationModel.CalculationType.edacs, new Date());
            redux.store.dispatch(saveCalculation(pathwayId, edacsCalculation, calculations));
            workflow.rawData['calculatedEDACS'] = edacsScore;
        }

        if (formComplete && patientEligable) {
            riskBracket = GPChestPainCalculationHelper.getRiskBracket(workflow.rawData);
        }

        if (riskBracket != null) {
            if ((riskBracket.type != workflow.rawData['pathwayRiskCategory'])) {
                riskBracketRequiresUpdate = true;
            }
        } else if (workflow.rawData['pathwayRiskCategory'] != null) {
            riskBracketRequiresUpdate = true;
        }

        if (workflow.rawData['probabilityOfMACE'] != maceScore) {
            maceRequiresUpdate = true;
        }

        if (riskBracketRequiresUpdate) {
            let riskBracketCalculation = new CalculationModel(workflow.uuid, workflow.versionUuid, riskBracket == null ? null : riskBracket.type, false, CalculationModel.CalculationType.riskCategory, new Date());
            redux.store.dispatch(saveCalculation(pathwayId, riskBracketCalculation, calculations));
            workflow.rawData['pathwayRiskCategory'] = riskBracket == null ? null : riskBracket.type;
        }

        if (maceRequiresUpdate) {
            let maceCalculation = new CalculationModel(workflow.uuid, workflow.versionUuid, maceScore, false, CalculationModel.CalculationType.probabilityOfMace, new Date());
            redux.store.dispatch(saveCalculation(pathwayId, maceCalculation, calculations));
            workflow.rawData['probabilityOfMACE'] = maceScore;
        }

        let lastViewedCalculations = {};
        if (redux.store.getState().calculationReducer.lastObservedCalculations[pathwayId] != null) {
            lastViewedCalculations = JSON.parse(JSON.stringify(redux.store.getState().calculationReducer.lastObservedCalculations[pathwayId]));
        }

        let changesStrings = [];
        if (edacsRequiresUpdate || riskBracketRequiresUpdate || maceRequiresUpdate) {
            if (edacsRequiresUpdate) {
                let lastEdacsValueKey = Object.keys(lastViewedCalculations).filter((calculation) => {
                    return lastViewedCalculations[calculation].type == CalculationModel.CalculationType.edacs;
                });

                if ((lastEdacsValueKey.length == 0 && workflow.rawData['calculatedEDACS'] != null)) {
                    changesStrings.push('EDACS Score');
                } else if (lastEdacsValueKey.length > 0 && lastViewedCalculations[lastEdacsValueKey[0]].value != workflow.rawData['calculatedEDACS']) {
                    changesStrings.push('EDACS Score');
                } else {
                    redux.store.dispatch(removeResultsAlertValue(pathwayId, 'EDACS Score'));
                }
            }

            if (riskBracketRequiresUpdate) {
                let lastRiskCategoryKey = Object.keys(lastViewedCalculations).filter((calculation) => {
                    return lastViewedCalculations[calculation].type == CalculationModel.CalculationType.riskCategory;
                });

                if (lastRiskCategoryKey.length == 0 && workflow.rawData['pathwayRiskCategory'] != null) {
                    changesStrings.push('Pathway Risk Category');
                } else if(lastRiskCategoryKey.length > 0 &&  lastViewedCalculations[lastRiskCategoryKey[0]].value != workflow.rawData['pathwayRiskCategory']) {
                    changesStrings.push('Pathway Risk Category');
                } else {
                    redux.store.dispatch(removeResultsAlertValue(pathwayId, 'Pathway Risk Category'));
                }
            }

            if (maceRequiresUpdate) {
                let lastMACEKey = Object.keys(lastViewedCalculations).filter((calculation) => {
                    return lastViewedCalculations[calculation].type == CalculationModel.CalculationType.probabilityOfMace;
                });
                if (lastMACEKey.length == 0 && workflow.rawData['probabilityOfMACE'] != null) {
                    changesStrings.push('Probability Of MACE');
                } else if (lastMACEKey.length > 0 && lastViewedCalculations[lastMACEKey[0]].value != workflow.rawData['probabilityOfMACE']) {
                    changesStrings.push('Probability Of MACE');
                } else {
                    redux.store.dispatch(removeResultsAlertValue(pathwayId, 'Probability Of MACE'));
                }
            }
        }

        if (changesStrings.length > 0) {
            //redux.store.dispatch(postResultsAlert(pathwayId, changesStrings));
            redux.store.dispatch(postResultsBadge(pathwayId));
        }
    }
}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Calculations/GPChestPain-Calculations.js